import { createRoot } from "react-dom/client";
import Confirm, { confirmProps } from "../../components/Generic/ConfirmDialog";

export interface ShowConfirmDialogOptions {
    title?: string;
    messageType?: confirmProps["messageType"];
    okText?: string;
    showCancel?: boolean;
}

export function showConfirmDialog(message: string, options?: ShowConfirmDialogOptions): Promise<boolean> {
    return new Promise<boolean>(resolve => {
        const container = document.createElement("div");
        document.body.appendChild(container);
        const root = createRoot(container);

        const cleanup = () => {
            root.unmount();
            container.remove();
        };

        root.render(
            <Confirm
                title={"Alert"}
                messageType={"info"}
                oKText={options?.okText}
                onConfirm={() => {
                    cleanup();
                    resolve(true);
                }}
                onCancel={
                    options?.showCancel === false
                        ? undefined
                        : () => {
                              cleanup();
                              resolve(false);
                          }
                }
            >
                <>{message}</>
            </Confirm>,
        );
    });
}
